import React, { useEffect, useState, useRef } from "react";
import styles from "../Styles/DashboardHeader.module.css";
import { motion, AnimatePresence } from "framer-motion";
import { FaMailBulk } from "react-icons/fa";
import { VscBellDot } from "react-icons/vsc";
import BulkEmailSender from "../components/Bulkmessages";
import Notifications from "../components/Notifications";
import useLogout from "../hooks/useLogout";
import { FiLogOut } from "react-icons/fi";



function Dashboardheader({ header, subheader }) {
  const handleLogout = useLogout();
  const [activeIcon, setActiveIcon] = useState(null);
  const [toolTip, setToolTip] = useState(false);

  const mailModalRef = useRef(null);
  const bellModalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideMail =
        mailModalRef.current && !mailModalRef.current.contains(event.target);
      const clickedOutsideBell =
        bellModalRef.current && !bellModalRef.current.contains(event.target);

      if (
        (activeIcon === "mail" && clickedOutsideMail) ||
        (activeIcon === "bell" && clickedOutsideBell)
      ) {
        setActiveIcon(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeIcon]);

  const handleToggle = (iconName) => {
    setActiveIcon((prev) => (prev === iconName ? null : iconName));
  };
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.menu_info}>
          <h2 className={styles.company_title}>{header}</h2>
          <p className={styles.company_sub_title}>{subheader}</p>
        </div>
        <div>
          <div className={styles.menu_bar}>
            <div className={styles.menu_bar_content}>
              <motion.div
                animate={{ scale: [1, 1.3, 1] }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  repeatType: "loop",
                  ease: "easeInOut",
                }}
              >
                <FaMailBulk
                  onClick={() => handleToggle("mail")}
                  onMouseEnter={() => setToolTip(true)}
                  onMouseLeave={() => setToolTip(false)}
                  color="rgba(24, 20, 243, 1)"
                  size={30}
                  style={{ cursor: "pointer" }}
                />
                {toolTip && <p className={styles.tooltip}></p>}
              </motion.div>

              <motion.div
                animate={{ scale: [1, 1.5, 1] }}
                transition={{
                  duration: 1.3,
                  repeat: Infinity,
                  repeatType: "loop",
                  ease: "easeInOut",
                }}
              >
                <VscBellDot
                  onClick={() => handleToggle("bell")}
                  color="rgba(24, 20, 243, 1)"
                  size={30}
                  style={{ cursor: "pointer" }}
                />
              </motion.div>
              <button className={styles.mobile_logout}  onClick={handleLogout}><FiLogOut  /></button>
            </div>
          </div>
          <AnimatePresence>
            {activeIcon === "mail" && (
              <motion.div
                key="mail-modal"
                ref={mailModalRef}
                initial={{ y: -1000, opacity: 0 }}
                animate={{ y: -200, opacity: 1 }}
                exit={{ y: 200, opacity: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                style={{
                  position: "fixed",
                  top: "42%",
                  right: "5%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1000,
                  backgroundColor: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                }}
              >
                <BulkEmailSender />
              </motion.div>
            )}

            {activeIcon === "bell" && (
              <motion.div
                key="bell-modal"
                ref={bellModalRef}
                initial={{ x: 200, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 200, opacity: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                style={{
                  position: "fixed",
                  top: "15%",
                  right: "2%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 1000,
                  backgroundColor: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                }}
              >
                <Notifications />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}

export default Dashboardheader;
